import * as React from 'react';
import clsx from 'clsx';

import { FormParserContext } from 'src/contexts/form.context';
import { Checkbox as CheckboxItem } from 'src/components/Checkbox';

import classes from './Checkbox.module.scss';

export function Checkbox() {
  const { value, script, onChange, isDisabled } = React.useContext(FormParserContext);

  function handleOnChange() {
    onChange(!value);
  }

  return (
    <div className={clsx(classes.container, 'row a-center')}>
      <CheckboxItem
        label={script.placeholder}
        isChecked={value ?? script.defaultValue}
        onClick={handleOnChange}
        isDisabled={isDisabled}
        tooltip={script.tooltip}
        tooltipPosition={script.tooltipPosition}
      />
    </div>
  );
}
